module.exports = __webpack_public_path__ + "8a41934c2b95a5015f183488cd4258b9.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/head/wasistgoldencity3.jpg
// module id = 785
// module chunks = 0